import {
  EDUCATION_LOADING,
  EDUCATION_SUCCESS,
  EDUCATION_FAILED,
  EDUCATION_ADD_LOADING,
  EDUCATION_ADD_SUCCESS,
  EDUCATION_ADD_FAILED,
  EDUCATION_REMOVE_LOADING,
  EDUCATION_REMOVE_SUCCESS,
  EDUCATION_REMOVE_FAILED,
  EDUCATION_UPDATE_CAMPUS_HIRE_LOADING,
  EDUCATION_UPDATE_CAMPUS_HIRE_SUCCESS,
  EDUCATION_UPDATE_CAMPUS_HIRE_FAILED,
  EDUCATION_SAVE_LOADING,
  EDUCATION_SAVE_SUCCESS,
  EDUCATION_SAVE_FAILED,
  MRL_DOCUMENT_LOADING,
  MRL_DOCUMENT_RESET,
  MRL_DOCUMENT_SUCCESS,
  MRL_DOCUMENT_FAILED
} from "../Constants/educationConstants";

export const educationReducer = (
  state = { educationData: [] },
  action
) => {
  switch (action.type) {
    case EDUCATION_LOADING:
      return { loading: true, educationData: [] };
    case EDUCATION_SUCCESS:
      return { loading: false, educationData: action.payload };
    case EDUCATION_FAILED:
      return { loading: false, error: action.educationData };
    default:
      return state;
  }
};


export const educationAddReducer = (
  state = { educationAddData: [] },
  action
) => {
  switch (action.type) {
    case EDUCATION_ADD_LOADING:
      return { loading: true, educationAddData: [] };
    case EDUCATION_ADD_SUCCESS:
      return { loading: false, educationAddData: action.payload };
    case EDUCATION_ADD_FAILED:
      return { loading: false, error: action.educationAddData };
    default:
      return state;
  }
};


export const educationRemoveReducer = (
  state = { educationRemoveData: [] },
  action
) => {
  switch (action.type) {
    case EDUCATION_REMOVE_LOADING:
      return { loading: true, educationRemoveData: [] };
    case EDUCATION_REMOVE_SUCCESS:
      return { loading: false, educationRemoveData: action.payload };
    case EDUCATION_REMOVE_FAILED:
      return { loading: false, error: action.educationRemoveData };
    default:
      return state;
  }
};


export const educationUpdateCampusHireReducer = (
  state = { educationUpdateCampusHireData: [] },
  action
) => {
  switch (action.type) {
    case EDUCATION_UPDATE_CAMPUS_HIRE_LOADING:
      return { loading: true, educationUpdateCampusHireData: [] };
    case EDUCATION_UPDATE_CAMPUS_HIRE_SUCCESS:
      return { loading: false, educationUpdateCampusHireData: action.payload };
    case EDUCATION_UPDATE_CAMPUS_HIRE_FAILED:
      return { loading: false, error: action.educationUpdateCampusHireData };
    default:
      return state;
  }
};

export const educationSaveReducer = (
  state = { educationSaveData: [] },
  action
) => {
  switch (action.type) {
    case EDUCATION_SAVE_LOADING:
      return { loading: true, educationSaveData: [] };
    case EDUCATION_SAVE_SUCCESS:
      return { loading: false, educationSaveData: action.payload };
    case EDUCATION_SAVE_FAILED:
      return { loading: false, error: action.educationSaveData };
    default:
      return state;
  }
};

export const MRLDocumentReducer = (
  state = { MRLDocumentData: {} },
  action
) => {
  switch (action.type) {
    case MRL_DOCUMENT_LOADING:
      return { loading: true, MRLDocumentData: {...state.MRLDocumentData} };
    case MRL_DOCUMENT_SUCCESS:
      return { loading: false, MRLDocumentData: {...state.MRLDocumentData,...action.payload} };
    case MRL_DOCUMENT_FAILED:
      return { loading: false, MRLDocumentData: {} };
    case MRL_DOCUMENT_RESET:
      return { loading: false, error: action.MRLDocumentData };
    default:
      return state;
  }
};
